<template>
  <header class="site-header">
    <!-- Top Bar -->
    <div class="top-bar py-2">
      <div class="container d-flex justify-content-center justify-content-md-between align-items-center">
        <div class="d-none d-md-flex align-items-center">
          <a href="https://discord.gg/xalor" target="_blank" class="top-link">
            <i class="fab fa-discord mr-2"></i> Join Discord Community
          </a>
        </div>
        <div class="d-flex align-items-center auth-links">
          <template v-if="!isAuthenticated">
            <router-link to="/login" class="top-link">Login</router-link>
            <span class="mx-2 text-muted">or</span>
            <router-link to="/register" class="top-link">Register</router-link>
          </template>
        </div>
      </div>
    </div>

    <!-- Main Navigation -->
    <nav class="navbar navbar-expand-md rs-navbar">
      <div class="container py-1 d-flex justify-content-between align-items-center">
        <!-- Logo -->
        <router-link to="/" class="navbar-brand me-4">
          <img src="@/assets/img/nav-logo.png" alt="Xalor Logo" class="nav-logo" />
        </router-link>

        <!-- Navigation Links (Desktop) -->
        <div class="collapse navbar-collapse" id="navbarContent">
          <ul class="navbar-nav me-auto mb-2 mb-md-0 d-flex flex-column flex-md-row align-items-center">
            <li class="nav-item"><a href="https://discord.gg/xalor" class="nav-link">Discord</a></li>
            <li class="nav-item"><router-link to="#" class="nav-link">Wiki</router-link></li>
            <template v-if="!isAuthenticated">
            <li class="nav-item"><router-link to="/register" class="nav-link">Register</router-link></li>
            </template>
          </ul>
        </div>

        <div class="d-flex align-items-center nav-actions ms-auto">
          <!-- Visible AFTER 768px (Desktop), hidden on Mobile -->
          <router-link to="/download" class="btn-gold btn-nav d-none d-md-inline-flex me-3">
            <i class="fas fa-download mr-1"></i> DOWNLOAD
          </router-link>
          
          <div class="authenticated-actions" v-if="isAuthenticated">
             <div class="dropdown">
                <a class="dropdown-toggle text-white d-flex align-items-center" href="#" role="button" id="userMenu" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="fas fa-user-circle fa-lg"></i>
                </a>
                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userMenu">
                    <li><router-link to="/account" class="dropdown-item">Account Settings</router-link></li>
                    <li class="dropdown-divider"></li>
                    <li><a href="#" class="dropdown-item" @click="signOut">Logout</a></li>
                </ul>
             </div>
          </div>

          <!-- Mobile Toggle (Hard Right) - only shows below 768px -->
          <button class="navbar-toggler d-md-none ms-3" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
            <i class="fas fa-bars text-white"></i>
          </button>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
  computed: {
    isAuthenticated() {
      const user = this.$store.state.user;
      return user && Object.keys(user).length > 0;
    },
    username() {
      return this.$store.state.user?.name || '';
    },
    email() {
      return this.$store.state.user?.email || '';
    },
    displayName() {
      const user = this.$store.state.user;
      if (!user || !this.isAuthenticated) return 'Account';
      // Use displayName if available, otherwise fall back to username (name)
      return user.displayName || user.name || 'Account';
    }
  },
  methods: {
    signOut() {
      this.$store.dispatch('logout');
      this.$router.push('/');
    }
  }
};
</script>
